<template>
    <div class="card shadow"
         :class="type === 'dark' ? 'bg-default': ''">
        <div class="card-header border-0"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="mb-0">{{ title }}</h3>
                </div>
                <div class="col text-right">
                    <base-button @click.prevent="filterModal = true;" type="primary">
                        Spalten ein/ausblenden
                    </base-button>
                </div>
                <div class="col text-right">
                    <el-input
                        type="search"
                        class=""
                        clearable
                        prefix-icon="el-icon-search"
                        style="width: 250px"
                        placeholder="Suche"
                        v-model="search"
                        aria-controls="datatables"
                    >
                    </el-input>
                </div>
            </div>
        </div>
        <modal v-model:show="modal" modal-classes="modal-xl modal-dialog-centered modal-dialog-scrollable">
            <template v-slot:header></template>
            <div class="card mt--2">
                <vue-pdf-embed :source="pdf"/>
            </div>
            <template v-slot:footer>
                <base-button @click.prevent="downloadContract" type="primary">
                    <span class="fad fa-download mr-1"/> Download
                </base-button>
            </template>
        </modal>
        <div class="table-responsive">
            <el-table @row-click="getContract"
                      type="index"
                      ref="contractsTable"
                      class="table-responsive clickableRow"
                      :class="type === 'dark' ? 'table-dark': ''"
                      :header-row-class-name="type === 'dark' ? 'thead-dark': ''"
                      :default-sort="{ prop: 'endDate', order: 'descending' }"
                      empty-text="Keine Einträge vorhanden"
                      :span-method="spanMethod"
                      @sort-change="changeSort"
                      :data="filteredContracts">
                <el-table-column prop="contractId" label="Vertragsnummer" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']" v-if="table.contractId.visible">
                    <template v-slot="{ row }">
                        <template v-if="loadingId === row.contractId && loadingFId === row.contractFId">
                            <div class="loaderInfo"><img class="loader" src="img/loading.gif" alt="loader"></div>
                        </template>
                        <template v-else class="text-center">
                            {{
                                (row.contractId) ? row.contractId : ''
                            }}{{ (row.contractFId) ? "/" + row.contractFId : '' }}
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="description" label="Name" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']" v-if="table.description.visible">
                    <template v-slot="{ row }">
                        {{ (row.description) ? row.description : '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="startDate" label="Gültig von" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']" v-if="table.startDate.visible">
                    <template v-slot="{ row }">
                        {{ (row.startDate) ? row.startDate : '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="endDate" label="Gültig bis" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']" v-if="table.endDate.visible">
                    <template v-slot="{ row }">
                        {{ (row.endDate) ? row.endDate : '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="amount" label="Betrag" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']" v-if="table.amount.visible">
                    <template v-slot="{ row }">
                        {{
                            (row.amount) ? parseFloat(row.amount).toLocaleString('de-CH', {
                                style: 'currency',
                                currency: 'CHF'
                            }) : ''
                        }}
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <base-button class="exportCSV" title="exportieren" @click.prevent="exportCSV()"
                         type="success">
                exportieren
            </base-button>
            <div class=""
                 :class="type === 'dark' ? 'bg-transparent': ''">
                <base-pagination v-model="pagination" :total="total" :perPage="perPage"></base-pagination>
            </div>
        </div>
        <base-alert v-if="error.length > 0" type="danger">
            <span class="alert-inner--text"><strong>Fehler!</strong>  {{ error }}</span>
        </base-alert>
    </div>
    <modal v-model:show="filterModal" @close="filterModal = false"
           modal-classes="modal-sm modal-dialog-centered d-flex justify-content-center">

        <div v-for="(column, key) in table" class="ml-3">
            <el-checkbox v-model="table[key].visible" :label="column.header"></el-checkbox>
        </div>
        <base-button class="resetFilter ml-3" title="zurücksetzen" @click.prevent="resetTableColumns()"
                     type="warning">
            Zurücksetzen
        </base-button>

        <div class="row ">
        </div>
    </modal>
</template>
<script>
import moment from 'moment';
import swal from 'sweetalert2';
import UserService from '@/services/user.service';
import Modal from "@/components/Modal";
import BaseAlert from "@/components/BaseAlert";
import VuePdfEmbed from 'vue-pdf-embed';
import * as jsonexport from "jsonexport/dist";
import {
    ElTable,
    ElTableColumn,
    ElDropdownMenu,
    ElDropdownItem,
    ElDropdown,
    ElInput,
    ElSelect,
    ElOption,
    ElCard,
    ElCheckbox,
} from "element-plus";

export default {
    name: 'contracts-table',
    components: {
        Modal,
        BaseAlert,
        VuePdfEmbed,
        [ElTable.name]: ElTable,
        [ElTableColumn.name]: ElTableColumn,
        [ElDropdown.name]: ElDropdown,
        [ElDropdownItem.name]: ElDropdownItem,
        [ElDropdownMenu.name]: ElDropdownMenu,
        [ElInput.name]: ElInput,
        [ElSelect.name]: ElSelect,
        [ElOption.name]: ElOption,
        [ElCard.name]: ElCard,
        [ElCheckbox.name]: ElCheckbox,
    },
    props: {
        type: {
            type: String
        },
        title: String,
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        filteredContracts() {
            if (this.search === '') {
                this.total = this.contracts.length;
                return this.contracts.filter((item, idx) => (idx >= this.start && idx < this.start + this.perPage));
            } else {
                const entries = this.contracts.filter(item => {
                    let props = Object.values(item);
                    return props.some(prop => !this.search.toLowerCase() || ((typeof prop === 'string') ? prop.toLowerCase().includes(this.search.toLowerCase()) : prop.toString(10).toLowerCase().includes(this.search.toLowerCase())))
                });
                this.total = entries.length;
                return entries.filter((item, idx) => (idx >= this.start && idx < this.start + this.perPage));
            }
        },
    },
    methods: {
        spanMethod({row, column, rowIndex, columnIndex}) {
            if (this.loadingId === row.contractId) {
                if (columnIndex === 0) {
                    return [1, 6]
                } else {
                    return [0, 0]
                }
            }
        },
        changeSort(sort) {
            this.currentSort = (!sort.prop) ? '' : sort.prop;
            this.currentSortDir = (!sort.order) ? '' : sort.order;
            this.sortTable();
        },
        sortTable() {
            this.contracts.sort((a, b) => {
                let modifier = 1;
                if (this.currentSortDir === 'descending') modifier = -1;
                if (this.currentSort.includes('Id') || this.currentSort === 'amount') {
                    if (parseFloat(a[this.currentSort]) < parseFloat(b[this.currentSort])) return -1 * modifier;
                    if (parseFloat(a[this.currentSort]) > parseFloat(b[this.currentSort])) return modifier;
                }
                if (this.currentSort.toLowerCase().includes('date')) {
                    if (a[this.currentSort].split('.').reverse().join('') < b[this.currentSort].split('.').reverse().join('')) return -1 * modifier;
                    if (a[this.currentSort].split('.').reverse().join('') > b[this.currentSort].split('.').reverse().join('')) return modifier;
                }
                if (a[this.currentSort].toLowerCase() < b[this.currentSort].toLowerCase()) return -1 * modifier;
                if (a[this.currentSort].toLowerCase() > b[this.currentSort].toLowerCase()) return modifier;
                return 0;
            });
        },
        convertDate(date) {
            return moment(date).format('DD.MM.YYYY HH:mm');
        },
        getError(error) {
            if (error.response && error.response.status == '401') {
                this.error = 'you are not logged in!';
            } else if (error.response && error.response.status == '403') {
                this.error = 'you are not permitted!';
            } else {
                this.error =
                    (error.response && error.response.data) ||
                    error.message ||
                    error.toString();
            }
        },
        getContracts() {
            UserService.getContracts().then(
                response => {
                    this.contracts = response.data.data;
                    this.sortTable();
                    this.total = response.data.recordsTotal;
                    this.error = '';
                    this.disabled = false;
                    this.$emit("changed", response.data);
                },
                error => {
                    this.getError(error);
                }
            );
        },
        getContract(row) {
            if (this.downloadLink != null) {
                this.downloadLink.remove();
            }
            if (this.loadingId !== row.contractId) {
                this.loadingId = row.contractId;
                this.loadingFId = row.contractFId;
                if(row.source === 0) {
                    UserService.getContract(row.contractId, row.contractFId).then(
                        response => {
                            const url = window.URL.createObjectURL(new Blob([response.data], {type: "application/pdf"}));
                            this.pdf = url;
                            const link = document.createElement('a');
                            link.href = url;
                            link.target = '_blank'
                            link.setAttribute('download', 'vertrag_' + this.loadingId + '_' + this.loadingFId + '.pdf');
                            document.body.appendChild(link);
                            this.downloadLink = link;
                            this.loadingId = 0;
                            this.loadingFId = 0;
                            this.modal = true;
                        });
                } else {
                    UserService.getContractREST(row.contractId, row.contractFId).then(
                        response => {
                            const url = window.URL.createObjectURL(new Blob([response.data], {type: "application/pdf"}));
                            this.pdf = url;
                            const link = document.createElement('a');
                            link.href = url;
                            link.target = '_blank'
                            link.setAttribute('download', 'vertrag_' + this.loadingId + '_' + this.loadingFId + '.pdf');
                            document.body.appendChild(link);
                            this.downloadLink = link;
                            this.loadingId = 0;
                            this.loadingFId = 0;
                            this.modal = true;
                        });
                }
            }
        },
        exportCSV() {
            let exported = []
            for (const contract of this.contracts) {
                let data = {}
                for (const e in this.table) {
                    if (this.table[e].visible) {
                        data[this.table[e].CSVHeader] = contract[e];
                    }
                }
                exported.push(data);
            }
            jsonexport(exported, {rowDelimiter: ';' }, (err, csv) => {
                let element = document.createElement('a');
                element.setAttribute('href', 'data:text/csv;charset=utf-16,' + encodeURIComponent(csv));
                element.setAttribute('download', 'Verträge.csv');
                element.style.display = 'none';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            } )
        },
        downloadContract() {
            this.downloadLink.click();
        },
        getTableColumns() {

            if (sessionStorage.getItem('contractsTable') !== null) {
                return JSON.parse(sessionStorage.getItem('contractsTable'));
            } else {
                return {
                    contractId: {visible: true, header: "Vertragsnummer", key: "contractId", CSVHeader:'Vertragsnummer'},
                    description: {visible: true, header: "Name", key: "description", CSVHeader:'Name'},
                    startDate: {visible: true, header: "Gültig von", key: "startDate", CSVHeader:'von'},
                    endDate: {visible: true, header: "Gültig bis", key: "endDate", CSVHeader:'bis'},
                    amount: {visible: true, header: "Betrag", key: "amount", CSVHeader:'Betrag'},
                };
            }
        },

        resetTableColumns() {
            this.table = {
                contractId: {visible: true, header: "Vertragsnummer", key: "contractId", CSVHeader:'Vertragsnummer'},
                description: {visible: true, header: "Name", key: "description", CSVHeader:'Name'},
                startDate: {visible: true, header: "Gültig von", key: "startDate", CSVHeader:'von'},
                endDate: {visible: true, header: "Gültig bis", key: "endDate", CSVHeader:'bis'},
                amount: {visible: true, header: "Betrag", key: "amount", CSVHeader:'Betrag'},
            };
            sessionStorage.removeItem('contractsTable');
        }

    },
    created() {

        this.getContracts();
        this.table = this.getTableColumns();

    },
    data() {
        return {
            contracts: [],
            downloadLink: null,
            modal: false,
            filterModal: false,
            currentSort: 'endDate',
            currentSortDir: 'descending',
            loading: 0,
            loadingId: 0,
            loadingFId: 0,
            search: '',
            disabled: true,
            error: '',
            newRequest: '',
            pdf: '',
            pagination: 1,
            total: 0,
            start: 0,
            perPage: 10,
            table: {},

        }
    },
    watch: {
        modal() {
            if (!this.modal && this.downloadLink != null) {
                this.downloadLink.remove();
            }
        },
        pagination() {
            this.start = (this.pagination - 1) * this.perPage;
        },
        table: {
            handler(value) {
                sessionStorage.setItem('contractsTable', JSON.stringify(value));
            }, deep: true
        },
    }
}
</script>
<style scoped lang="scss">
:root {
    --ck-border-radius: 0.375rem;
}

.loader {
    height: 100%;
}
.exportCSV {
    line-height: 0.5!important;
    height: 36px;
    overflow: hidden!important;
}

div.loaderInfo {
    padding: 0;
    margin: 0;
    background: white;
    height: 3.5em;
}

.ck-editor__editable {
    min-height: 150px;
}

.clickableRow {
    tbody tr td {
        cursor: pointer;
    }

    .el-table__expanded-cell {
        cursor: default;
    }
}

thead th {
    cursor: pointer;
}
</style>
<style lang="scss">

canvas {
    height: auto !important;
}
</style>
